import React from 'react';
import './Loader.css';
import LoadingOverlay from 'react-loading-overlay';

class Loader extends React.Component {

  render() {
    return (<div className="Loader" style={{display: (this.props.active ? 'block' : 'none')}}>
      <LoadingOverlay active={this.props.active} spinner={true} text={this.props.text}>

      </LoadingOverlay>
    </div>)
  }
}
export default Loader;